import HttpService from "./httpService";

export const getMemberCounts = (size, offset, sortBy, sortDir, year) => {
  let uri = `/chapter/membercounts?size=${size}&offset=${offset}&sortBy=${sortBy}&sortDir=${sortDir}`;
  if (year >= 0) {
    uri = `${uri}&year=${year}`;
  }
  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const getMemberCount = id => {
  const uri = `/chapter/membercounts/${id}`;
  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const getChapterAnalysisReports = year => {
  let uri = `/chapter/chapteranalysisreports?year=${year}`;
  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const createMemberCount = body => {
  const uri = `/chapter/membercount`;

  return async () => {
    return HttpService.postRequest(uri, body);
  };
};

export const updateMemberCount = body => {
  const uri = `/chapter/membercount`;

  return async () => {
    return HttpService.putRequest(uri, body);
  };
};

export const getCurrentFiscalYear = () => {
  const uri = "/chapter/fiscalyear";

  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const getChapterFinancials = () => {
  const uri = `/chapter/chapterfinancials`;
  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const getChapterFinancial = id => {
  const uri = `/chapter/chapterfinancial/${id}`;
  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const getChapterFinancialByYear = year => {
  let uri = `/chapter/chapterfinancials?year=${year}`;

  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const submitChapterFinancial = (id, notes) => {
  const uri = `/chapter/chapterfinancial/${id}/submit?notes=${notes}`;
  return async () => {
    return HttpService.putRequest(uri);
  };
};

export const getChapterBudgets = () => {
  const uri = `/chapter/chapterbudgets`;
  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const getChapterBudget = id => {
  return async () => {
    return HttpService.getRequest(`/chapter/chapterbudget/${id}`);
  };
};

export const createChapterBudget = body => {
  const uri = `/chapter/chapterbudget`;
  return async () => {
    return HttpService.postRequest(uri, body);
  };
};

export const updateChapterBudget = body => {
  const uri = `/chapter/chapterbudget`;
  return async () => {
    return HttpService.putRequest(uri, body);
  };
};

export const updateChapterBudgetFile = (id, body) => {
  const uri = `/chapter/chapterbudget/${id}/upload`;
  return async () => {
    return HttpService.postRequest(uri, body, {
      "Content-Type": "multipart/form-data"
    });
  };
};

export const downloadChapterBudgetFile = filename => {
  const uri = `/chapter/download/${filename}`;
  return async () => {
    return HttpService.getRequestWithHeader(uri, {
      responseType: "blob"
    });
  };
};

export const getChapterFinancialsDefaults = () => {
  const uri = `/chapter/chapterfinancials/defaults`;
  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const createReportItem = body => {
  const uri = `/chapter/chapterfinancial/reportitem`;
  return async () => {
    return HttpService.postRequest(uri, body);
  };
};

export const updateReportItem = (id, body) => {
  const uri = `/chapter/chapterfinancial/reportitem`;
  return async () => {
    return HttpService.putRequest(uri, {
      ...body,
      id
    });
  };
};

export const removeReportItem = id => {
  const uri = `/chapter/chapterfinancial/reportitem/${id}`;
  return async () => {
    return HttpService.deleteRequest(uri);
  };
};

export const updateReportItems = body => {
  const uri = `/chapter/chapterfinancial/reportitems`;
  return async () => {
    return HttpService.postRequest(uri, body);
  };
};

export const updateReportItemsPut = body => {
  const uri = `/chapter/chapterfinancial/reportitems`;
  return async () => {
    return HttpService.putRequest(uri, body);
  };
};

export const initialReportItems = body => {
  const uri = `/chapter/chapterfinancial/initialreportitems`;
  return async () => {
    return HttpService.postRequest(uri, body);
  };
};

export const updateReportW2 = body => {
  const uri = `/chapter/chapterfinancial/reportw21099`;
  return async () => {
    return HttpService.putRequest(uri, body);
  };
};

export const updateVotingCount = body => {
  const uri = `/chapter/chapterfinancial/votingcount`;
  return async () => {
    return HttpService.putRequest(uri, body);
  };
};

export const createFinancialAccount = body => {
  const uri = `/chapter/chapterfinancial/financialaccount`;
  return async () => {
    return HttpService.postRequest(uri, body);
  };
};

export const updateFinancialAccount = body => {
  const uri = `/chapter/chapterfinancial/financialaccount`;
  return async () => {
    return HttpService.putRequest(uri, body);
  };
};

export const removeFinancialAccount = id => {
  const uri = `/chapter/chapterfinancial/financialaccount/${id}`;
  return async () => {
    return HttpService.deleteRequest(uri);
  };
};

export const getHelpTextByType = (typeid, subtypeid) => {
  return async () => {
    return HttpService.getRequest(
      `/chapter/helptext?typeid=${typeid}&subtypeid=${subtypeid}`
    );
  };
};

export const getChapterSummaryReport = id => {
  const uri = `/chapter/reports/chaptersummary/${id}`;
  return async () => {
    return HttpService.getRequest(uri, { responseType: "blob" });
  };
};

export const getYearToYearReport = id => {
  const uri = `/chapter/reports/yeartoyear/${id}`;
  return async () => {
    return HttpService.getRequest(uri, { responseType: "blob" });
  };
};

export const getComparativeReport = id => {
  const uri = `/chapter/reports/comparative/${id}`;
  return async () => {
    return HttpService.getRequest(uri, { responseType: "blob" });
  };
};
